import { render } from "./adminLogin.vue?vue&type=template&id=52d497d2&scoped=true"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"

import "./adminLogin.vue?vue&type=style&index=0&id=52d497d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d497d2"]])

export default __exports__